module.exports = __webpack_public_path__ + "public-ui/img/user.9e2b5425.svg";